var _g, _path, _circle, _ellipse, _line, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostFailOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_798_12996)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.9943,
    y: 25.0056,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#672C78"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 49.9978L41.9979 40.9999M41.9979 40.9999L33 50.002M41.9979 40.9999L42.002 58.9999",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 32,
    r: 9,
    fill: "#F7E237"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.1502,
    cy: 36.1496,
    rx: 0.999919,
    ry: 0.99991,
    fill: "#222222"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 60.15,
    y1: 27.4003,
    x2: 60.15,
    y2: 32.2749,
    stroke: "#222222",
    strokeWidth: 1.99983,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_798_12996",
    x: 0.428572,
    y: 0.142858,
    width: 83.1429,
    height: 83.1429,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -8.28571
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.28571
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_798_12996"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_798_12996",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostFailOpen);
export default __webpack_public_path__ + "static/media/post_fail_open.397652300372b0c469d2113b4c412af0.svg";
export { ForwardRef as ReactComponent };